// @ts-nocheck
/* eslint-disable */
import { _ } from "~/i18n";
import { node, icon } from "~/util/dom";

export function zoomControl() {
	const cont = node("div", { className: "zoom" });
	const fsButton = node("button", { className: "photo-fullscreen", title: _("photo.fullscreen") });
	const plus = node("button", { className: "plus", title: _("zoomMenu.zoomIn") });
	const minus = node("button", { className: "minus", title: _("zoomMenu.zoomOut") });

	fsButton.setAttribute("data-log-ignore", "1");
	plus.setAttribute("data-log-ignore", "1");
	minus.setAttribute("data-log-ignore", "1");

	fsButton.appendChild(icon("fullscreen-on"));
	fsButton.appendChild(icon("fullscreen-off"));
	plus.appendChild(icon("plus"));
	minus.appendChild(icon("minus"));

	cont.appendChild(fsButton);
	cont.appendChild(plus);
	cont.appendChild(minus);

	return cont;
};
